import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheBncStandard() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="15924" id="the-brendon-j-standard" ref={sectionRef} className="w-full flex flex-col lg:flex-row min-h-[600px] bg-background text-foreground">
      {}
      <div className="w-full lg:w-[60%] relative min-h-[400px] lg:min-h-auto overflow-hidden">
        <div className={`absolute inset-0 transition-transform duration-1000 ease-out ${isVisible ? "scale-100" : "scale-105"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/craftsman_laying_stone_walkway.png" alt="Director Brendon James overseeing industrial supply operations" className="w-full h-full object-cover grayscale contrast-110 brightness-90" />
        </div>
        {}
        <div className="absolute inset-0 bg-primary/20 lg:hidden"></div>
      </div>

      {}
      <div className="w-full lg:w-[40%] bg-primary text-primary-foreground flex flex-col justify-center p-8 md:p-12 lg:p-16 xl:p-20 relative">
        <div className={`flex flex-col gap-6 transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-serif font-bold tracking-tighter text-primary-foreground uppercase">
            The Brendon J Standard
          </h2>

          <div className="w-16 h-1 bg-accent mb-2"></div>

          <div className="space-y-6 text-primary-foreground/90 font-sans leading-relaxed text-lg">
            <p>
              Established in July 2023, BRENDON J BUILDING MATERIAL WHOLESALERS 
              PTY LTD (ACN: 669 488 386) is a cornerstone of the Australian 
              construction supply chain. Under the leadership of Director Brendon 
              James, we bridge the gap between manufacturing and large-scale 
              project execution.
            </p>
            <p>
              Based in Victoria, our operations are built on the pillars of 
              reliability and compliance. We ensure that every wholesale order—from 
              structural steel to specialized plumbing—adheres to the highest 
              Australian standards, providing B2B partners with the scale and 
              quality required for modern infrastructure.
            </p>
          </div>

          <div className="pt-8 mt-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/bnc_signature.png" alt="Brendon J Building Material Wholesalers Official Signature" className="h-16 w-auto opacity-100 invert brightness-0" style={{
            filter: "brightness(0) saturate(100%) invert(96%) sepia(6%) saturate(168%) hue-rotate(338deg) brightness(98%) contrast(90%)"
          }} />
            <p className="text-sm text-primary-foreground/70 mt-3 font-mono tracking-widest uppercase">
              Reliability. Compliance. Scale.
            </p>
          </div>
        </div>
      </div>
    </section>;
}